
export type EntityType =
    "digitalsignering" |
    "avtal" |
    "kontrakt" |
    "atgard" |
    "certifikat" |
    "utskrift" |
    "tradslag" |
    "avverkningsanmalan" |
    "leverantorer" |
    "skogsvardsatgard" |
    "betalning" |
    "skogsvardsatgardovrigt" |
    "skogsvardsatgardforyngring" |
    "skogsvardsatgarddetaljer" ;

export enum RuleSeverityLevel {
    info,
    warning,
    error
}

export enum RuleErrorContext {
    save,
    rapportutskrift,
    vacs
}

export enum RuleVisibilityStrategy {
    alwaysShow,
    preSave,
    postSave,
    confirm
}

export class RuleValidationMessage {
    message: string;
    messageId: string;
    severity: RuleSeverityLevel;
    strategy: RuleVisibilityStrategy;
    context: RuleErrorContext;
    entityType?: EntityType;
    entityGuids: string[];
}
